export default __webpack_public_path__ + "static/media/element_24.4d91feaa.jpg";